import React from 'react';
import { ShieldCheck, Users, Search, Map, Truck, Clock } from 'lucide-react';
const TRUST_ITEMS = [{
  icon: ShieldCheck,
  title: '22+ years of industry experience',
  subtext: 'Residential, commercial, and streetscape products.'
}, {
  icon: Users,
  title: 'Family-owned & woman-owned',
  subtext: 'A real team you can call before ordering.'
}, {
  icon: Search,
  title: 'Free diagnostic & estimating help',
  subtext: 'Send photos for model, part, or replacement guidance.'
}, {
  icon: Map,
  title: 'USPS-aware project guidance',
  subtext: 'Helpful for CBUs, 4C systems, parcel lockers, and replacements.'
}, {
  icon: Truck,
  title: 'Free shipping on commercial mailbox systems',
  subtext: 'Commercial mailbox systems ship free nationwide; contact MidAtlantic for help confirming the right system before ordering.'
}, {
  icon: Clock,
  title: 'Extended support until 8 PM ET',
  subtext: 'Reach Laura directly at 240-575-5852 after regular business hours.'
}];
export function TrustRail() {
  return <section aria-label="Why shop with MidAtlantic" className="bg-white border-b border-brand-border pt-8 pb-12 lg:pt-10 lg:pb-14 relative z-20" data-id="element-497" data-mp="16siyu53otoic">
      <div className="max-w-7xl mx-auto px-4" data-id="element-498" data-mp="1bq2g7dvomhei">
        <div className="text-center mb-8" data-id="element-499" data-mp="1gri032m4ihvb">
          <span className="text-brand-maroon font-bold tracking-wider uppercase text-xs flex items-center justify-center gap-2" data-id="element-500" data-mp="1gp5iwro6wbjb">
            <span className="w-8 h-px bg-brand-gold" data-id="element-501" data-mp="o2b162irbq9j"></span>
            Why shop with MidAtlantic
            <span className="w-8 h-px bg-brand-gold" data-id="element-502" data-mp="t1xfkfabncjx"></span>
          </span>
          <h2 className="text-xl lg:text-2xl font-serif font-bold text-brand-charcoal mt-2" data-id="element-503" data-mp="szkqli65c1xd">
            Expertise and support behind every order
          </h2>
        </div>

        {/* Mobile: horizontal scroll, Desktop: grid */}
        <div className="flex overflow-x-auto pb-4 lg:pb-0 lg:grid lg:grid-cols-3 gap-4 lg:gap-6 snap-x snap-mandatory hide-scrollbar" data-id="element-504" data-mp="5bjj8ckperjj">
          {TRUST_ITEMS.map((item, idx) => {
          const Icon = item.icon;
          return <div key={idx} className="flex-shrink-0 w-72 lg:w-auto snap-start flex flex-col items-start gap-3 p-4 rounded-lg bg-white border border-brand-border hover:border-brand-gold transition-colors" data-id="element-505" data-mp="3oh57wlbn04pj" data-mpi={idx}>
                <div className="w-10 h-10 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center shrink-0" data-id="element-506" data-mp="3ahnhy2mlulel">
                  <Icon size={20} strokeWidth={1.5} data-id="element-507" data-mp="35k3z0peypkgb" />
                </div>
                <div data-id="element-508" data-mp="3kgcxhor13tro">
                  <h4 className="font-bold text-brand-charcoal text-sm mb-1 leading-tight" data-id="element-509" data-mp="3kguq8behfpuu">
                    {item.title}
                  </h4>
                  <p className="text-xs text-brand-muted leading-relaxed" data-id="element-510" data-mp="zpu7zzo8wybk">
                    {item.subtext}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}